import applicants from "./applicants";
import appliedJobs from "./appliedJobs";
import applyJob from "./applyJob";
import createJob from "./createJob";
import getApplicantJobs from "./getApplicantJobs";
import getEmployersJobs from "./getEmployersJobs";
import job from "./job";
import jobs from "./jobs";
import removeJob from "./removeJob";
import searchJobs from "./searchJobs";
import unapplyJob from "./unapplyJob";
import updateJob from "./updateJob";

const jobReducer = {
  applicants,
  getApplicantJobs,
  job,
  jobs,
  applyJob,
  createJob,
  removeJob,
  updateJob,
  searchJobs,
  unapplyJob,
  appliedJobs,
  getEmployersJobs,
};

export default jobReducer;
